import React from 'react';

import cn from 'classnames';
import { func, bool, shape, element, string } from 'prop-types';

import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';

import ClickableComponent from 'components/Common/ClickableComponent';
import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';

import s from './Switcher.css';

const Switcher = ({ setAnchor, anchor, isMobile, selectedOption, options }) => {
  const item = options[selectedOption];

  return (
    <ClickableComponent
      className={cn(s.selectedItem, { [s.mobile]: isMobile })}
      onClick={e => (anchor ? null : setAnchor(e.currentTarget))}
    >
      {!isMobile && <div className={s.icon}>{item?.icon}</div>}
      <div className={s.selectionDetail}>
        <div className={s.selectedMode}>SELECTED MODE</div>
        <div className={s.selectedName}>{item?.title}</div>
      </div>

      <div className={s.arrow}>
        <FontAwesomeIcon icon={anchor ? faChevronUp : faChevronDown} />
      </div>
    </ClickableComponent>
  );
};

Switcher.propTypes = {
  setAnchor: func.isRequired,
  isMobile: bool.isRequired,
  selectedOption: string.isRequired,
  anchor: element,
  options: shape({}).isRequired,
};

Switcher.defaultProps = {
  anchor: null,
};

export default Switcher;
